import * as vp from 'vopay';
import axios from 'axios';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type HookTuple = (requestParams: vp.ELinxSettingsSetReminderRequest) => Promise<vp.ApiResponse>;

function usePostELinxSettingsSetReminder({ api }: HookProps): HookTuple {
  const source = axios.CancelToken.source();
  return (requestParams) => api.postELinxSettingsSetReminder(requestParams, source);
}

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostELinxSettingsSetReminder);
